export default {
    to(vue, pathParameter, dados) {
        vue.$router.push({
            name: pathParameter,
            params: {hide: true, dados: dados, redirect: vue.$route.meta.redirect},
            meta: {redirect: vue.$route.meta.redirect}
        });
    },
    getRotaDestino(vue) {
        var retorno = "";
        if (!!vue.$route.meta.redirect) {
            retorno = vue.$route.meta.redirect;
        } else if (!!vue.$route.params.redirect) {
            retorno = vue.$route.params.redirect;
        } else {
            if (vue.$defaultAuthRoutePath) {
                retorno = vue.$defaultAuthRoutePath;
            } else {
                retorno = "/";
            }
        }
        var path = vue.$router.resolve({path: retorno}).resolved;
        if (path) {
            return path.name;
        } else {
            return ""
        }
    }
}
